const LS_KEY = 'page_tabs_workspace_project_names';

/** 与 workspace 项目名称缓存同步监听，便于页签 Tooltip 即时更新 */
export const WORKSPACE_TAB_TITLE_UPDATED_EVENT = 'boss-workspace-tab-title-updated';

/**
 * 缓存条目按 scope 命名空间隔离，避免不同 workspace 的 ID 冲突：
 * - 医项目（默认）保持裸 id 形式，向下兼容存量数据
 * - 其他 workspace（如 conference）使用 `${scope}:${id}` 形式
 * @param {string} scope
 * @param {string} id
 */
function buildCacheKey(scope, id) {
    return scope === 'medproject' ? id : `${scope}:${id}`;
}

/**
 * 持久化 workspace 项目名称，供 PageTabs Tooltip 读取。
 * @param {string | number | undefined | null} projectId
 * @param {string} name
 * @param {string} [scope='medproject'] workspace 维度（默认医项目，会议传 'conference'）
 */
export function rememberWorkspaceProjectTabTitle(projectId, name, scope = 'medproject') {
    if (projectId == null || projectId === '' || typeof name !== 'string' || !name.trim()) {
        return;
    }
    try {
        const map = JSON.parse(localStorage.getItem(LS_KEY) ?? '{}');
        if (typeof map !== 'object' || map === null) return;
        const cacheKey = buildCacheKey(scope, String(projectId));
        map[cacheKey] = name.trim();
        localStorage.setItem(LS_KEY, JSON.stringify(map));
        window.dispatchEvent(
            new CustomEvent(WORKSPACE_TAB_TITLE_UPDATED_EVENT, {
                detail: { projectId: String(projectId), scope },
            }),
        );
    } catch {
        // quota / privacy mode
    }
}

/**
 * @param {string | number | undefined | null} projectId
 * @param {string} [scope='medproject']
 * @returns {string}
 */
export function getWorkspaceProjectTabTitle(projectId, scope = 'medproject') {
    if (projectId == null || projectId === '') return '';
    try {
        const map = JSON.parse(localStorage.getItem(LS_KEY) ?? '{}');
        const raw = map[buildCacheKey(scope, String(projectId))];
        return typeof raw === 'string' ? raw : '';
    } catch {
        return '';
    }
}
